/**
 * UserList
 * --
 */
import React, { useState, useEffect } from 'react';
import { Button, Table, Spin } from 'antd';
import { Content, Title, Row, Col, ModalLayout } from 'components';
import moment from 'moment';
import MessageAlert, { strCut, stringToMoneyFormat } from 'utils';
import * as XLSX from 'xlsx/xlsx.mjs';
import { UserDetail } from 'routes/admin.routes/admin.users';
import { downloadXlsx } from 'utils/XlsxDownloader';
/**----------------------------------------
 * [Component] JM페이 > 유저목록
 * ----------------------------------------
 */
const UserList = ({ data, currentRow, setCurrentRow, onSelect }) => {
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  // console.log('currentRow: ', currentRow);
  const col = [
    {
      title: '유저등급',
      dataIndex: 'grade',
      width: 145,
      align: 'center',
      render: (value) => value?.grade_name,
    },
    {
      title: '회원명',
      dataIndex: 'user_name',
      width: 200,
      align: 'center',
      render: (value, record) => (
        <a
          style={{ textDecoration: 'underline' }}
        >{`${value}(${record?.user_gender}, ${record?.user_nickname})`}</a>
      ),
    },
    {
      title: '생년월일',
      dataIndex: 'user_birthday',
      width: 130,
      align: 'center',
      render: (value) => moment(value * 1000).format('YYYY-MM-DD'),
    },
    {
      title: '연락처',
      dataIndex: 'user_phone',
      width: 150,
      align: 'center',
    },
    {
      title: '유저상태',
      dataIndex: 'account_status',
      width: 120,
      align: 'center',
    },

    {
      title: 'JM페이 잔액',
      dataIndex: 'jm_pay',
      width: 150,
      align: 'center',
      render: (value) => stringToMoneyFormat(value),
      sorter: (a, b) => a.jm_pay - b.jm_pay,
    },

    {
      title: '유저메모',
      dataIndex: 'memo',
      align: 'center',
      render: (value) => strCut(value, 20),
    },
  ];
  // JSX: start
  return (
    <>
      <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
        {/* === 상단 > 타이틀 === */}
        <Title
          size={5}
          style={{ marginBottom: 7.5 }}
          subButton={
            <Button
              onClick={() =>
                downloadXlsx({
                  columns: col,
                  rows: data?.map((_item) => ({
                    ..._item,
                    grade: _item?.grade?.grade_name,
                    user_name: `${_item?.user_name}(${_item?.user_gender},${_item?.user_nickname})`,
                    user_birthday: moment(_item?.user_birthday * 1000)?.format(
                      'YYYY-MM-DD'
                    ),
                  })),
                  fileName: '제이엠페이_이용자_목록',
                })
              }
            >
              엑셀로 다운로드
            </Button>
          }
        >
          이용자 목록({data?.length ?? 0})
        </Title>

        {/* ===== 데이터 테이블: start ===== */}
        <div style={{ overflow: 'auto', width: '100%', height: '100%' }}>
          <Table
            className="boxShadow"
            bordered
            size="small"
            dataSource={data ?? []}
            scroll={{
              x: 'max-content',
            }}
            style={{ minHeight: 580 }}
            onRow={(record) => {
              return {
                onClick: () => setCurrentRow(record), // 행 클릭 시 이벤트 처리
              };
            }}
            columns={col}
          />
        </div>
        {/* ===== 데이터 테이블: end ===== */}
      </Content>

      {/* ===== 상세모달: start ===== */}
      <ModalLayout
        type="drawer"
        maxWidth={900}
        isOpen={currentRow !== null}
        open={currentRow !== null}
        title="상세보기"
        closable={true}
        onCancel={() => setCurrentRow(null)}
      >
        {currentRow && (
          <UserDetail
            defaultUserId={currentRow?.user_id ?? null}
            manageType="JM_PAY"
          />
        )}
      </ModalLayout>
      {/* ===== 상세모달: end ===== */}
    </>
  ); // JSX: end
};

UserList.defaultProps = {
  onSelect: () => {},
};
export default UserList;
